export const isAdminUser = (user) => {
  if (!user || typeof user !== "object") return false;

  const role = String(user.role || "").toLowerCase();
  const roles = Array.isArray(user.roles)
    ? user.roles.map((item) => String(item).toLowerCase())
    : [];

  return role.includes("admin") || roles.some((item) => item.includes("admin"));
};

export const parseJsonSafe = (value, fallback = null) => {
  if (!value || value === "undefined" || value === "null") return fallback;

  try {
    return JSON.parse(value);
  } catch (error) {
    return fallback;
  }
};

export const getAdminSession = () => {
  const token = localStorage.getItem("adminToken");
  const refreshToken = localStorage.getItem("adminRefreshToken");
  const user = parseJsonSafe(localStorage.getItem("adminUser"), null);

  return {
    token: token && token !== "undefined" ? token : "",
    refreshToken:
      refreshToken && refreshToken !== "undefined" ? refreshToken : "",
    user,
  };
};

export const clearAdminSession = () => {
  localStorage.removeItem("adminToken");
  localStorage.removeItem("adminRefreshToken");
  localStorage.removeItem("adminUser");
};
